import { render, staticRenderFns } from "./ExtraInformation.vue?vue&type=template&id=20e475a2"
import script from "./ExtraInformation.vue?vue&type=script&lang=js"
export * from "./ExtraInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports